export default {"src":"/_next/static/media/yard-maintenance.0d09af45.svg","height":23,"width":30,"blurWidth":0,"blurHeight":0};